import React from 'react';
import SideBarStateProvider from './SideBar/SideBarStateProvider';
import CollapsedSideBarOverlay from './SideBar/CollapsedSideBarOverlay';
import PinnedSideBar from './SideBar/PinnedSideBar';

const SidebarDiv = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <PinnedSideBar children={children} />
      <CollapsedSideBarOverlay children={children} />
    </>
  );
};

const Gate = ({ children }: { children: React.ReactNode }) => {
  return (
    <SideBarStateProvider>
      <SidebarDiv children={children}></SidebarDiv>
    </SideBarStateProvider>
  );
};

export default Gate;
